"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.converter = void 0;
const common_1 = require("@finley-technologies/common");
const tape_builder_base_1 = require("../../../types/tape-builder-base");
const utils_1 = require("../../utils");
const uinode_1 = require("../generated-cash-balance-feed/uinode");
const types_1 = require("./types");
const uinode_2 = require("./uinode");
// converts intermediate records to 1 or more UI nodes.
const intermediateToUINodes = (tape) => {
    (0, common_1.finleyAssert)(uinode_2.file_directInsertBorrowingBaseReport.isIntermediateRecord(tape), `intermediateToUINodes: expected ${types_1.artifactType} but found [artifactType:${tape.type}]`);
    const { id: tapeBuilderNodeId, configuration, artifactSlug, creditFacilitySlug, } = tape;
    const { generatedCashBalanceFeedArtifactSlug: _unused, ...remainingConfig } = configuration;
    const tapeNode = {
        metadata: {
            tapeBuilderNodeId,
            tapeBuilderNodeType: types_1.nodeType,
        },
        configuration: {
            artifactSlug,
            creditFacilitySlug,
            ...remainingConfig,
        },
    };
    return {
        operationNode: null,
        tapeNode,
    };
};
// converts UI nodes to intermediate records.
// returns new record and old record ids to be replaced.
const uiNodesToIntermediate = (params) => {
    const { artifactDocumentId, node, graph } = params;
    (0, common_1.finleyAssert)(uinode_2.file_directInsertBorrowingBaseReport.isNode(node), `uiNodesToIntermediate: node is not a directInsertBorrowingBaseReport [nodeType:${node.metadata.tapeBuilderNodeType}]`);
    const { artifactSlug, creditFacilitySlug, ...configuration } = node.configuration;
    const inputNodes = (0, utils_1.getSourceNodes)({ node, graph });
    const generatedCashInputs = inputNodes.filter(uinode_1.file_generatedCashBalanceFeed.isNode);
    (0, common_1.finleyAssert)(generatedCashInputs.length <= 1, `When converting from UI to intermediate for direct insert borrowing base report [artifactSlug:${artifactSlug}], expected 0 or 1 generated cash balance feed input node, but received ${generatedCashInputs.length}`);
    const generatedCashBalanceFeedArtifactSlug = generatedCashInputs.length === 1
        ? (0, tape_builder_base_1.asArtifactSlugRef)(generatedCashInputs[0].configuration.artifactSlug)
        : null;
    const record = {
        id: node.metadata.tapeBuilderNodeId,
        artifactDocumentId,
        type: types_1.artifactType,
        artifactSlug,
        creditFacilitySlug,
        loanProductSlug: null,
        externalFilename: null,
        configuration: { ...configuration, generatedCashBalanceFeedArtifactSlug },
    };
    return {
        record,
        operationNode: null,
    };
};
exports.converter = {
    artifactType: types_1.artifactType,
    nodeType: types_1.nodeType,
    intermediateToUINodes,
    uiNodesToIntermediate,
};
//# sourceMappingURL=converter.js.map